import {reducerWithInitialState} from "typescript-fsa-reducers";
import { tableInitialState, deepCopyTableThingyState } from "../typing/tablestates";
import {BreadCrumpActions} from '../actions/table_actions';

export default reducerWithInitialState(tableInitialState)
        .case(BreadCrumpActions.setCrumbs, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            if (payload.entry){
                deepCopy.model.entry.main = payload.entry.main;
                deepCopy.model.entry.sub = payload.entry.sub;
                deepCopy.model.link.main = payload.link.main;
                deepCopy.model.link.sub = payload.link.sub;
            }
            deepCopy.view.loaded = true;
            return deepCopy;
        })
        ;